export class SaasCommitmentWindowCost {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "startTime",
            "baseName": "startTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endTime",
            "baseName": "endTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "usedSeats",
            "baseName": "usedSeats",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "committedSeats",
            "baseName": "committedSeats",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "seatCost",
            "baseName": "seatCost",
            "type": "number",
            "format": ""
        },
        {
            "name": "seatCharges",
            "baseName": "seatCharges",
            "type": "Array<SaasSeatCharge>",
            "format": ""
        },
        {
            "name": "ransomwareProtectionEnabled",
            "baseName": "ransomwareProtectionEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "ransomwareSeatCharges",
            "baseName": "ransomwareSeatCharges",
            "type": "Array<SaasSeatCharge>",
            "format": ""
        },
        {
            "name": "ransomwareCost",
            "baseName": "ransomwareCost",
            "type": "number",
            "format": ""
        },
        {
            "name": "storageCapBytes",
            "baseName": "storageCapBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "ransomwareUsedSeats",
            "baseName": "ransomwareUsedSeats",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "ransomwareCommittedSeats",
            "baseName": "ransomwareCommittedSeats",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "overageCost",
            "baseName": "overageCost",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SaasCommitmentWindowCost.attributeTypeMap;
    }
    constructor() {
    }
}
